import { getAxios } from '../../../../lib/axios';
import { ActivityEndpoints } from '../../../../constants/endpoints/activityEndpoints.ts';
import { useQuery } from '@tanstack/react-query';
import { AddressV2 } from '../../../../globalModels/locations/address';
import { FrontierRoomTypeViewModel } from '../../../../globalModels/hotels/frontier/frontierRoomTypes.ts';

export type ActivityInformationHotelModel = {
  AgentNotes: string[];
  CodeRedNotes: string[];
  RoomTypes: FrontierRoomTypeViewModel[];
  Address: AddressV2;
  BookingMethod: string | undefined;
  BookingMethodNotes: string | undefined;
  CancellationPolicy: string | undefined;
  ChainCode: string | undefined;
  Email: string | undefined;
  PaymentEmail: string | undefined;
  FaxNumber: string | undefined;
  GdsId: string | undefined;
  NonGdsId: string | undefined;
  Notes: string[];
  PaymentNotes: string | undefined;
  PhoneNumber: string | undefined;
  Website: string | undefined;
  WebsiteNotes: string | undefined;
  HotelName: string;
  CustomPayments: HotelCustomPayment[];
  CompanyUnpreferred: string;
  CompanyUnpreferredNotes: boolean;
  FrontierPreferred: boolean;
  FrontierUnPreferred: boolean;
  PreferenceNotes: string;
  RequiresSertifiCanaryNotes: string;
  IsCamp: boolean;
};

type HotelCustomPayment = {
  Notes: string;
  FileName: string;
  FileHandle: string;
};

export function useActivityInformationHotelQuery(hotelIds: number[]) {
  return useQuery<ActivityInformationHotelModel[]>({
    queryKey: [ActivityEndpoints.information.hotels(hotelIds), hotelIds],
    queryFn: async () => (await getAxios().get(`${ActivityEndpoints.information.hotels(hotelIds)}`)).data,
    enabled: hotelIds != undefined && hotelIds?.length != 0
  });
}

export function useActivityInformationHotelQuerySingle(hotelId: number | undefined) {
  return useQuery<ActivityInformationHotelModel>({
    queryKey: ['hotelInformationSingle', ActivityEndpoints.information.hotels([hotelId!]), [hotelId]],
    enabled: hotelId != undefined && typeof hotelId == 'number' && hotelId > 0,
    queryFn: async () => (await getAxios().get(`${ActivityEndpoints.information.hotels([hotelId!])}`)).data[0]
  });
}
export type ActivityInformationHotelContractModel = {
  ChargeFee: boolean;
  DynamicRateCommission: number | undefined;
  DynamicRateCode: string | undefined;
  IsServiceFeeOnly: boolean;
  StaticRateCommission: number | undefined;
  StaticRateCode: string | undefined;
};
